define(["document-ready-promise", "jquery"], function(ready, $) {
  var glossary = {
    glossaryLinkList: null,

    init: function() {
      glossary.glossaryLinkList = glossary.getGlossaryLinkList();
      glossary.initialiseSearch();
    },

    getGlossaryLinkList: function() {
      var glossaryList = $(".letter-container dt").map((index, element) => {
        return {
          id: $(element).attr("id"),
          value: $(element).text(),
        };
      });

      return $.makeArray(glossaryList);
    },

    initialiseSearch: function() {
      $("#glossary-search-form").on("submit", function(e) {
        e.preventDefault();
        return false;
      });

      $("#glossary-search-input").autocomplete({
        position: { my: "left top", at: "left bottom+3" },
        source: glossary.glossaryLinkList,
        minLength: 1,
        create: function() {
          $(this).data("ui-autocomplete")._renderItem = function(ul, item) {
            var link = $("<a>")
              .attr("href", "#" + item["id"])
              .prop("title", item["value"])
              .append(item["value"]);

            return $("<li>")
              .attr("data-value", "#" + item["id"])
              .append(link)
              .appendTo(ul);
          };
        },
        response: function(event, ui) {
          if (ui.content.length === 0) {
            $("#glossary-search-message").text(
              "No results were found matching your search term."
            );
            $("#glossary-search-message").removeClass("hidden");
          } else {
            $("#glossary-search-message").addClass("hidden");
          }
        },
      });
    },
  };

  ready().then(function() {
    glossary.init();
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/glossary/glossary.js